import { Injectable } from '@angular/core';
import { Constants } from '../config/Constants';
import { ContentsMandatory } from '../models/contents-mandatory';
import { AngularFireDatabase, AngularFireObject } from 'angularfire2/database';
import { ProfileImageUpload } from '../models/profile-image-upload';
import * as firebase from 'firebase';
import { Category } from '../models/category';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { UtilityService } from './utility.service';

@Injectable()
export class MultiUtilityService {

	constructor(private db: AngularFireDatabase, private utilityService: UtilityService) {
	}

	addContentMandatory(contentsMandatory: ContentsMandatory): string {
		return this.db.list(Constants.EVENT_URL + '/' + contentsMandatory.eventId + Constants.Contents_Mandatory_URL)
			.push(contentsMandatory).key;
	}


	pushUpload(profileImageUpload: ProfileImageUpload, eventId, cmType: string) {
		let fileName = profileImageUpload.file.name;
		let storageRef = firebase.storage().ref();
		return storageRef.child(`${'/' + eventId + Constants.Contents_Mandatory_URL + '/' + cmType}/${fileName}`)
			.put(profileImageUpload.file);
	}


	getCategoryList(eventId: string, categoryListType: string) {
		let data: AngularFireObject<Category> = this.db.object(Constants.EVENT_URL + '/' + eventId + categoryListType);
		return data.valueChanges();
	}

	getCategoryItemName(eventId: string, categoryListType: string, categoryId: string) {
		let data: AngularFireObject<string> = this.db.object(Constants.EVENT_URL + '/' + eventId + categoryListType + "/" + categoryId + "/text");
		return data.valueChanges();
	}

	addCategoryItem(eventId: string, categoryList, categoryListType: string) {
		/* User for speaker, sponsor, organizer, exhibitor categories */

		if (categoryList) {
			let path = Constants.EVENT_URL + '/' + eventId + categoryListType;

			let keyArray: Array<string> = new Array();
			for (let item of categoryList) {
				if (item.$key == null) {
					console.log({ eventId, categoryList, categoryListType })
					keyArray.push(this.db.list(path).push({ key: item.$key, position: item.position, text: item.text }).key);
				} else {
					let updatedKey = item.$key;
					this.db.object(path + '/' + updatedKey).set({ position: item.position, text: item.text });
				}
			}
			return keyArray;
		}
	}

	addCategoryItem2(eventId: string, categoryList, categoryListType: string) {
		/* User for session hall/tracks/type categories */
		if (categoryList) {
			let path = Constants.EVENT_URL + '/' + eventId + categoryListType;

			let keyArray: Array<string> = new Array();
			for (let item of categoryList) {
				if (item.$key == null) {
					console.log({ eventId, categoryList, categoryListType })
					keyArray.push(this.db.list(path).push({ key: item.$key, position: item.position, name: item.name, color: item.color }).key);
				} else {
					let updatedKey = item.$key;
					const updatePayload = { position: item.position, name: item.name}
					if(item.color) updatePayload['color']= item.color
					this.db.object(path + '/' + updatedKey).set(updatePayload);
				}
			}
			return keyArray;
		}
	}

	deleteCategoryItem(eventId: string, categoryItemDeletedId, categoryListType: string): Promise<any> {
		return this.db.object(Constants.EVENT_URL + '/' + eventId + categoryListType + '/' + categoryItemDeletedId).set(null);
	}

	getContentsCMByID(id: string, eventId: string): Observable<ContentsMandatory> {
		let data: AngularFireObject<ContentsMandatory> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.Contents_Mandatory_URL + '/' + id);
		return data.valueChanges();
	}

	getFileURL(contentsMandatory: ContentsMandatory, eventId: string): Promise<any> {
		return firebase.storage().ref().child
			("/" + eventId + Constants.Contents_Mandatory_URL + "/" + contentsMandatory.category + "/" + contentsMandatory.filename).getDownloadURL();
	}

	uploadImageToStorage2(imageFile: File, firebase, eventId: string, cmType: string, dbKey: string): Observable<any> {
		// this.confirmMessage = null;

		if (imageFile != null) {


			let uploadTask = this.pushUpload(new ProfileImageUpload(imageFile), eventId, cmType);
			uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
				(snapshot) => {
					// this.disableButton = false;
					// this.confirmMessage = 'File uploading...';
					// let progres = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100);

					// imgType === Constants.IMAGE_UPLOAD_TYPE_BANNER ? (this.bannerUploadProgress = progres) : (this.iconUploadProgress = progres);
					return null;
				},
				(error) => {
					// this.errorMessage.push(error.message);
					// this.isError = true;
					return null;

				},
				() => {

					let contentsMandatory = new ContentsMandatory();
					contentsMandatory.category = cmType;
					contentsMandatory.eventId = eventId;
					contentsMandatory.filename = imageFile.name;
					contentsMandatory.extension = imageFile.type.split('/').pop();
					contentsMandatory.sizeInBytes = imageFile.size;
					//XYZ - should be a separate service
					let key: string = this.addContentMandatory(contentsMandatory);
					if (key) {

						// dbKey = key;
						// return key.asO
						return of(key);
						// imageFile = null;
						// this.disableButton = true;
						// this.confirmMessage = 'File Uploaded Successfully';
					} else {
						return null;
					}
				}
			);
		} else {
			return null;
		}
	}

	updatePrefListing(eventId: string, listingOf: string, status: boolean) {
		return this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.PREDERENCES_URL + '/' + Constants.PREF_LISTING_URL + '/' + listingOf).set(status);
	}

	updatePrefHiding(eventId: string, type: string, pref: boolean) {
		return this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.PREDERENCES_URL + '/' + Constants.PREF_HIDE_IMAGE + '/' + type).set(pref);
	}

	getPrefListing(eventId: string, type: string): Observable<boolean> {
		if (this.utilityService.isLogged()) {
			let data: AngularFireObject<boolean> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.PREDERENCES_URL + '/' + Constants.PREF_LISTING_URL + '/' + type);
			return data.valueChanges();
		}
		return of(false);
	}

	getPrefHiding(eventId: string, type: string): Observable<boolean> {
		if (this.utilityService.isLogged()) {
			let data: AngularFireObject<boolean> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.PREDERENCES_URL + '/' + Constants.PREF_HIDE_IMAGE + '/' + type);
			return data.valueChanges();
		}
		return of(false);
	}
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/multi-utility.service.ts